import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { StyledForm } from "../../../components/Form/FormComponents.styled";
import { CustomSmallBtn } from "../Lease.styled";
import { FaArrowLeft } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import {
	CompletedAssetInformation,
	CompletedAssetProductInfo,
	InsureAssetInfo,
} from "../partials/FormFields";
import FormAccordion from "../../../components/Form/FormAccordion";
import { AssetRegistrationSideBar } from "../partials/RegistrationSideBar";
import { getCurrentUserInfo } from "../../../utils/UserAuth";
import {
	getIdType,
	getInvestorEmail,
	getInvestorName,
	getVehicleType,
	investorApplyForInsurance,
	removeCountryCode,
	reverseDate,
} from "../utils";
import { useDispatch, useSelector } from "react-redux";
import { getInsurancePaymentStatus, onUpdateAsset, updateLogObject } from "../../logistics/utils";
import { Backdrop } from "@mui/material";
import { InsureAssetModal } from "../partials/RegAndInsuranceModal";
import useParameters from "../../../utils/useParameters";
import { toast } from "react-toastify";
import { deductPaymentFromUserWallet, walletType } from "../../dashboard/DashboardUtils";
import { clearDeductWalletSuccess, deductFromWalletSuccess } from "../../../redux/WalletSlice";

const InsureAsset = ({ leaseData }) => {
	const parameters = useParameters();
	const navigate = useNavigate();
	const dispatch = useDispatch();
	const currentAdmin = getCurrentUserInfo();

	const { companyInsuranceInfo } = useSelector((state) => state.app);
	const { adminWallet, walletDetails, deductWalletMessage } = useSelector((state) => state.wallet);

	const [toggleEdit, setToggleEdit] = useState(false);
	const [regNum, setRegNum] = useState("");
	const [insureModal, setInsureModal] = useState(false);
	const [activeTab, setActiveTab] = useState(1);
	const [loading, setLoading] = useState({ paymentLoading: false, insuranceLoading: false });
	const [insuranceComplete, setInsuranceComplete] = useState(null);

	const isSingleInvestor = leaseData?.leaseType === "Sponsored Lease" && leaseData?.investors?.length === 1;

	const insuredData = leaseData?.insuranceDetails;

	const dataToUse = () => {
		if (isSingleInvestor) {
			return insuredData;
		} else if (insuredData) {
			return insuredData;
		} else {
			return companyInsuranceInfo?.companyInsuranceInfo;
		}
	};

	const { paymentStatus, isPaymentComplete } = getInsurancePaymentStatus(leaseData);

	const [insuranceInfo] = useState({
		dateInsured: insuredData?.dateInsured || "",
		investorName: getInvestorName(leaseData),
		investorEmail: getInvestorEmail(leaseData),
		investorPhone: dataToUse()?.phone || "",
		gender: isSingleInvestor ? insuredData?.gender : currentAdmin?.gender,
		occupation: dataToUse()?.occupation || "",
		dob: dataToUse()?.dob || "",
		country: "Nigeria",
		state: dataToUse()?.state || "",
		city: dataToUse()?.city || "",
		street: dataToUse()?.street || "",
		streetNumber: dataToUse()?.streetNumber || "",
		postalCode: dataToUse()?.postalCode || "",
		assetInvoice: leaseData?.vehicleInfo?.assetInvoice || leaseData?.assetInvoice,
		idCard: dataToUse()?.idCard || dataToUse()?.cacDoc || null,
		utilityBill: dataToUse()?.utilityBill || dataToUse()?.utilityDoc || null,
		paymentStatus,
		idType: dataToUse()?.idType || "",
		idNumber: dataToUse()?.idNumber || "",
		status: dataToUse()?.status,
		address: dataToUse()?.address,
	});

	const insuranceRate = parameters
		?.filter((p) => p?.parameter?.toLocaleLowerCase().includes("insurance rate"))
		?.find((a) => !!a?.value);

	const formattedInsuranceFee = Number(insuranceRate?.value?.replace("%", ""));

	const totalAmountToPay = (formattedInsuranceFee / 100) * Number(leaseData?.amount?.replaceAll(",", ""));

	const mainWallet = adminWallet?.find((wallet) => wallet?.product === walletType.main);

	const isInvoiceReady = leaseData?.assetInvoice || leaseData?.vehicleInfo?.assetInvoice;

	const isInsurancePaymentReady = () => {
		if (
			currentAdmin?.privileges === "firstLineApproval" &&
			currentAdmin?.role?.toLowerCase() === "finance" &&
			leaseData?.leaseType === "Quick Lease" &&
			isInvoiceReady &&
			!isPaymentComplete
		) {
			return true;
		}
		if (
			currentAdmin?.privileges?.toLowerCase() === "super administrator" &&
			leaseData?.leaseType === "Quick Lease" &&
			isInvoiceReady &&
			!isPaymentComplete
		) {
			return true;
		} else {
			return false;
		}
	};

	const isActivateInsuranceReady = () => {
		if (insuranceInfo?.status === "insured") {
			return false;
		}
		if (
			currentAdmin?.privileges === "firstLineApproval" &&
			currentAdmin?.role?.toLowerCase() === "finance" &&
			isPaymentComplete
		) {
			return true;
		}
		if (currentAdmin?.privileges?.toLowerCase() === "super administrator" && isPaymentComplete) {
			return true;
		} else {
			return false;
		}
	};

	const handleCancel = () => {
		setToggleEdit(false);
		setRegNum("");
	};

	const amount = process.env.NODE_ENV !== "development" ? totalAmountToPay : 1;

	const onBeginInsurancePayment = () => {
		if (!insuranceRate) {
			toast.error("Insurance fee is not available yet. Please check back later");
			return;
		}

		if (leaseData?.productCategory === "Vehicles") {
			toast.error("Only vehicles can be assured at this time.");
			return;
		}

		if (mainWallet?.availableBalance < amount) {
			toast.error("Insuffient balance. Please fund your wallet!");
			return;
		}
		setInsureModal(true);
		setActiveTab(1);
	};

	const handleUpdateForm = async (dataToUdpate, context, key) => {
		try {
			setLoading((prev) => ({ ...prev, [key]: true }));
			const response = await updateLogObject(leaseData?.objectId, dataToUdpate, "lease");

			if (leaseData?.assetObj) {
				const resTwo = await onUpdateAsset(leaseData?.assetObj?.id, dataToUdpate);

				console.log(resTwo);
			}

			if (response) {
				toast.success(
					context === "payment" ? "Insurance payment is successful" : "Asset has been insured successfully."
				);

				setTimeout(() => {
					window.location.reload();
				}, 2000);
			} else {
				throw Error("Error updating Object!");
			}
		} catch (error) {
			console.log(error);
			toast.error(error);
		} finally {
			setLoading((prev) => ({ ...prev, [key]: false }));
		}
	};

	const onInsurancePayment = async () => {
		const details = {
			walletId: walletDetails?.id,
			amount,
			narration: "asset-activation-fee",
		};

		try {
			setLoading({ ...loading, paymentLoading: true });
			const data = await deductPaymentFromUserWallet(details, "asset-insurance-fee-successful");

			dispatch(deductFromWalletSuccess(data));
		} catch (error) {
			toast.error(error);
		} finally {
			setLoading({ ...loading, paymentLoading: false });
		}
	};

	const insuranceDetails = {
		...insuranceInfo,
		address: companyInsuranceInfo?.companyInsuranceInfo?.companyInfo?.address,
	};

	// status: "Insured",
	// dateInsured: new Date().toISOString(),

	const vehicleValue = process.env.NODE_ENV !== "production" ? "4,500,000" : leaseData?.amount;

	const handleSubmitInsurance = async (e) => {
		e.preventDefault();

		if (!companyInsuranceInfo) {
			toast.error("Admin has not updated company details for insurance.");
			return;
		} else if (!leaseData?.vehicleRegDetails?.registrationNum) {
			toast.error("Vehicle registration number is not available yet.");
			return;
		} else {
			const dataToSubmit = {
				firstName: insuranceInfo?.investorName?.split(" ").slice(0, 1).join(),
				lastName: insuranceInfo?.investorName?.split(" ").slice(1).join(" "),
				dob: insuranceInfo?.dob ? reverseDate(insuranceInfo.dob) : "",
				gender: insuranceInfo.gender?.toLowerCase(),
				phone: insuranceInfo?.investorPhone ? removeCountryCode(insuranceInfo?.investorPhone) : "",
				email: insuranceInfo.investorEmail,
				idCardImgUrl: insuranceInfo.idCard?.url,
				utilityImgUrl: insuranceInfo.utilityBill?.url,
				address: insuranceInfo?.address,
				number: insuranceInfo.idNumber,
				expiry: dataToUse()?.expiryDate ? reverseDate(dataToUse()?.expiryDate) : "",
				type: getIdType(dataToUse()?.idType),
				occupation: insuranceInfo?.occupation,
				city: insuranceInfo?.city,
				state: insuranceInfo?.state,
				country: insuranceInfo?.country,
				street: insuranceInfo.street,
				streetNumber: insuranceDetails.streetNumber,
				postCode: insuranceDetails.postalCode,
				vehicleMake: leaseData?.brand,
				vehicleModel: leaseData?.model,
				vehicleYear: leaseData?.year,
				vehicleChassis: leaseData?.vehicleRegDetails?.chassisNum,
				vehicleRegNo: leaseData?.vehicleRegDetails?.registrationNum,
				vehicleEngNo: leaseData?.vehicleRegDetails?.engineNum,
				vehicleValue: Number(vehicleValue?.replaceAll(",", "")),
				vehicleUse: leaseData?.leaseStructure === "Operating Lease" ? "Commercial" : "Private",
				vehicleType: getVehicleType(leaseData?.subCategory),
				leaseId: leaseData?.objectId,
				assetId: leaseData?.assetObj?.id || "",
			};

			try {
				setLoading({ ...loading, insuranceLoading: true });
				const response = await investorApplyForInsurance(dataToSubmit);
				// console.log(response);
				if (response) {
					toast.success("You will be directed to a third party agent for insurance payment shortly.");
					setTimeout(() => {
						setInsuranceComplete(response);
					}, 1500);
				}
			} catch (error) {
				toast.error(error);
			} finally {
				setLoading({ ...loading, insuranceLoading: false });
			}
		}
	};

	const onPaymentSuccess = async () => {
		const insurancePaymentInfo = {
			percentage: insuranceRate?.value,
			totalAmount: totalAmountToPay,
			investors: [
				...(leaseData?.insurancePaymentInfo?.investors || []),
				{
					name: `${currentAdmin?.firstName} ${currentAdmin?.lastName}`,
					userId: "Fortcore Admin",
					amountPaid: totalAmountToPay,
					status: "paid",
					dateOfPayment: new Date().toISOString(),
				},
			],
		};

		handleUpdateForm({ insurancePaymentInfo, insuranceDetails }, "payment", "paymentLoading");
	};

	// const onInsuranceSuccessful = async () => {
	// 	handleUpdateForm({ insuranceDetails }, "insurance", "insuranceLoading");
	// };

	const onInsuranceSuccessful = () => {
		window.open(`${insuranceComplete?.paymentDetails?.paymentLink}`);
	};

	useEffect(() => {
		if (insureModal) {
			document.body.style.overflow = "hidden";
		}
		return () => {
			// eslint-disable-next-line no-undef
			document.body.style.overflow = "auto";
		};
	}, [insureModal]);

	// UPDATE REQUEST ON SUCCESSFUL PAYMENT
	useEffect(() => {
		if (deductWalletMessage === "asset-insurance-fee-successful") {
			dispatch(clearDeductWalletSuccess());
			onPaymentSuccess();
		}
	}, [deductWalletMessage]);

	// UPDATE REQUEST ON SUCCESSFUL INSURANCE
	useEffect(() => {
		if (insuranceComplete) {
			onInsuranceSuccessful();
		}
	}, [insuranceComplete]);

	return (
		<>
			<Backdrop sx={{ zIndex: 13 }} open={insureModal}>
				<InsureAssetModal
					activeTab={activeTab}
					setActiveTab={setActiveTab}
					onCloseModal={() => setInsureModal(false)}
					amountPayable={totalAmountToPay}
					handleInsurancePayment={onInsurancePayment}
					loading={loading.paymentLoading}
				/>
			</Backdrop>
			<div style={{ position: "relative" }}>
				<CustomSmallBtn
					style={{
						position: "absolute",
						left: "-20px",
						top: "-115px",
						background: "white",
						color: "#006770",
					}}
					onClick={() => navigate(-1)}>
					<FaArrowLeft />
					<span>Go Back</span>
				</CustomSmallBtn>
				<StyledForm onSubmit={handleSubmitInsurance}>
					<AssetRegistrationSideBar
						leaseData={leaseData}
						toggleEdit={toggleEdit}
						handleCancel={handleCancel}
						setToggleEdit={setToggleEdit}
						isEditable={isActivateInsuranceReady()}
						isInsurance
					/>
					<div className='RightSection'>
						<FormAccordion title='Insurance Information' open={true}>
							<InsureAssetInfo
								formData={leaseData}
								insurance={insuranceInfo}
								toggleEdit={toggleEdit}
								regNum={regNum}
								handleChange={(e) => setRegNum(e.target.value)}
								handleRegisterAsset={onBeginInsurancePayment}
								canRegisterAsset={isInsurancePaymentReady()}
							/>
						</FormAccordion>
						<FormAccordion title='Lease Information'>
							<CompletedAssetInformation formData={leaseData} />
						</FormAccordion>
						<FormAccordion title='Product Information'>
							<CompletedAssetProductInfo formData={leaseData} />
						</FormAccordion>
					</div>
				</StyledForm>
			</div>
		</>
	);
};

InsureAsset.propTypes = {
	leaseData: PropTypes.object,
};

export default InsureAsset;
